export default __webpack_public_path__ + "static/media/pic6.174e5d0c.jpg";